import IconWrapper from "./IconWrapper";

function SearchIcon() {
  return (
    <IconWrapper>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path fill="none" d="M16 0v16H0V0z" />
        <path d="M11.846 3.075a5.747 5.747 0 0 0-7.89-1.967 5.749 5.749 0 0 0 2.968 10.678c.85 0 1.705-.201 2.509-.594L11.721 15h1.167l-2.593-4.315a5.748 5.748 0 0 0 1.551-7.61zm-2.482 7.032a4.74 4.74 0 0 1-2.44.679 4.715 4.715 0 0 1-4.076-2.304 4.71 4.71 0 0 1-.538-3.595 4.717 4.717 0 0 1 2.162-2.921 4.74 4.74 0 0 1 2.44-.679c1.686 0 3.209.861 4.076 2.304.654 1.087.844 2.364.538 3.595s-1.075 2.268-2.162 2.921z" />
      </svg>
    </IconWrapper>
  );
}

export default SearchIcon;
